// Libraries
import { Center, Text, VStack } from "@chakra-ui/react";
import { useRouter } from "next/router";
import React, { ReactNode } from "react";

interface bottomNavProps {
  title: string;
  icon: ReactNode;
  location: string;
}

const BottomNavItem = ({ title, icon, location }: bottomNavProps) => {
  const router = useRouter();
  const color = router.pathname === location ? "blue.500" : "gray.500";

  return (
    <VStack spacing={2} w="33.3%">
      <Center
        cursor="pointer"
        borderTop="2px solid"
        borderTopColor={router.pathname === location ? "#070707" : "transparent"}
        onClick={() => router.push(location)}
        color={color}
        flexDir="column"
        textAlign="center"
        p={3}>
        <Text fontSize="2xl">
          {/* <HiOutlineCollection /> */}
          {icon}
        </Text>

        <Text fontSize="sm" fontWeight={700}>
          {title}
        </Text>
      </Center>
    </VStack>
  );
};

export default BottomNavItem;
